var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full flex flex-col mt-2"},[_c('Header',{attrs:{"show-close-chat":_vm.showCloseChat},on:{"close-connection":_vm.closeConnection}}),_c(_vm.renderComponent,{tag:"component",on:{"cancel-close":_vm.cancelClose,"close-chat":_vm.closeChat}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }